module.exports = "/_next/static/images/688533db92cf254e531e7978bd289647-hero-mobile.jpg.webp";